import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getVendorDetails = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/vendor-details/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor details fetch error:", error);
    throw error;
  }
};

const updateVendorDetails = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/vendor-details/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor details update error:", error);
    throw error;
  }
};

const deleteVendorDocument = async (documentId) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/vendor-details/?document_id=${documentId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor document delete error:", error);
    throw error;
  }
};

export { getVendorDetails, updateVendorDetails, deleteVendorDocument };
